"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const _4d_mapper_1 = require("4d-mapper");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const veflux_1 = require("vasat/dist/src/veflux");
const tree_events_1 = require("./tree-events");
class TreeComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.rootLevels = null;
        this._subs = [];
        this.change = new core_1.EventEmitter();
    }
    set selectedFolder(s) {
        this._selectedFolder = s;
    }
    set rootLevelStore(s) {
        this._rootLevelStore = s;
    }
    ngOnInit() {
        this.rootLevels = this._rootLevelStore.state;
    }
    ngOnDestroy() {
        this._subs.forEach(s => s.unsubscribe());
    }
    changed(ev) {
        this.change.emit(ev);
        // console.log('#changed TREE', ev.event, ev );
        if (!this.disableSelection && ev.event == 'selected' && this._selectedFolder) {
            this._selectedFolder.value = ev.item;
            this.cdr.detectChanges();
        }
    }
}
exports.TreeComponent = TreeComponent;
class TreeNodeComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.change = new core_1.EventEmitter();
        this.isSelected = false;
        this.isImported = false;
        this.children = null;
        this.id = null;
        this.subs = [];
    }
    ngOnInit() {
        this.folder.load();
        this.folder.redraw = () => this.cdr.detectChanges();
        this.isLeaf = this.folder.isLeaf;
        this.isFile = this.folder.selectable || this.folder.ref instanceof _4d_mapper_1.Dataset;
        if (this.folder.ref.id) {
            this.id = (this.isFile ? 'file-' : 'folder-') + this.folder.ref.id;
        }
        else {
            if (this.folder.ref.layer && this.folder.ref.layer.id) {
                this.id = (this.isFile ? 'file-' : 'folder-') + this.folder.ref.layer.id;
            }
            else {
                this.id = (this.isFile ? 'file-' : 'folder-') + this.uuid();
            }
        }
        if (this.folder['_imported']) {
            this.isImported = true;
        }
        console.log('#init_node', this.id, this.folder);
        if (!this.isLeaf) {
            if (this.folder.expanded) {
                // console.log('#toggle AUTO', this.id );
                this.toggle();
            }
            this.updateHasChildren();
        }
        if (this._selectedFolder) {
            this.subs.push(this._selectedFolder.events.subscribe(s => {
                if (!this.expanded && s.event == 'ADD' && s.item.ref != this.folder.ref && s.args && s.args.chain.indexOf(this.folder.ref) != -1) {
                    this.toggle();
                }
                // toggle selected status            
                if (s.event == 'ADD' && s.item.ref == this.folder.ref) {
                    this.isSelected = true;
                    this.cdr.detectChanges();
                }
                else if (s.event == 'REMOVE' && s.item.ref == this.folder.ref) {
                    this.isSelected = false;
                    this.cdr.detectChanges();
                }
            }));
        }
        this.cdr.detectChanges();
    }
    ngOnDestroy() {
        this.folder.unload();
        this.subs.forEach(s => s.unsubscribe());
    }
    updateHasChildren() {
        this.hasChildren = this.folder.hasChildren;
    }
    clicked() {
        // console.log('#clicked', this.id, this.folder);
        this.change.emit(new tree_events_1.TreeEvent(this.folder, 'selected'));
        this.cdr.detectChanges();
    }
    clickMe() {
        // console.log('#clickMe', this.id, this.isFile, this.folder );
        if (this.isFile) {
            // file clicked
            this.clicked();
        }
        else {
            // folder clicked
            this.toggle();
        }
    }
    toggle() {
        // console.log('#toggle', this.id, this.folder);
        if (!this.folder.hasChildren)
            return;
        if (!this.expanded) {
            this.change.emit(new tree_events_1.TreeEvent(this.folder, 'expanded'));
            if (!this.children) {
                this.children = [];
                this.subs.push(this.folder.children.events.pipe(operators_1.filter(ev => ev.event == 'UPDATE')).subscribe(_ => this.cdr.detectChanges()));
                this.subs.push(this.folder.children.state.subscribe(s => {
                    this.children = s;
                    this.cdr.detectChanges();
                }));
                this.change.emit(new tree_events_1.TreeEvent(this.folder, 'fetching_children'));
                this.folder.loadChildren().subscribe(s => {
                    this.change.emit(new tree_events_1.TreeEvent(this.folder, 'fetched_children', { children: s }));
                });
            }
        }
        else {
            this.change.emit(new tree_events_1.TreeEvent(this.folder, 'collapsed'));
        }
        this.expanded = !this.expanded;
    }
    onChecked(checked, item) {
        // console.log('#check', this.id, checked, item);
        this.change.emit(new tree_events_1.TreeEvent(this.folder, 'checked', checked));
        this.clicked();
    }
    uuid() {
        return 'xxx-xxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}
exports.TreeNodeComponent = TreeNodeComponent;
